<script lang="typescript">
  // components
  import ElectoralCollege from './ElectoralCollege.svelte';
  import NationalMap from './maps/NationalMap.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { NationalInterface, StateInterface } from '../interfaces';

  // props
  export let store: Readable<NationalInterface>;
  export let geography;

  // state
  let height = 0;

  $: resultsByFips = new Map(
    $store.president.states.map((state: StateInterface) => [state.code, state])
  );
</script>

<svelte:window bind:innerHeight={height} />

<ElectoralCollege {store} />

{#if height > 200}
  <NationalMap {geography} data={resultsByFips} />
{/if}
